export const APP_ROLES = {
  PARTNER_USER: 'selfservicepartneruser',
  DATACLOUD_USER: 'selfservicedataclouduser',
  TEMPLATE_ADMIN: 'selfservicetemplateadmin',
  PARTNER_ADMIN: 'selfservicepartneradmin',
  CERTIFICATE_ADMIN: 'selfservicecertificatemanager',
  SUPER_USER: 'selfservicesuperuser',
  RS_PARTNER: 'rsPartner',
  ACCOUNTS_RECEIVABLE: 'rsAdpAccountsReceivable',
  BILLING_ADMIN: 'rsAdpBillingAdmin',
  CIA_MANAGER: 'cia_manager',
  FINANCIAL_USER: 'selfservicefinancialuser'
};

export const appRolesMap = {
  [APP_ROLES.PARTNER_ADMIN]: 'Partner Admin',
  [APP_ROLES.DATACLOUD_USER]: 'DataCloud User',
  [APP_ROLES.TEMPLATE_ADMIN]: 'Template Admin',
  [APP_ROLES.PARTNER_USER]: 'Partner User',
  [APP_ROLES.CERTIFICATE_ADMIN]: 'Certificate Admin',
  [APP_ROLES.SUPER_USER]: 'Super User',
  [APP_ROLES.CIA_MANAGER]: 'CIA Admin',
  [APP_ROLES.RS_PARTNER]: 'Rev Share Partner',
  [APP_ROLES.BILLING_ADMIN]: 'Rev Share Admin'
}

export const ACCELERATOR_STATUS = {
  PARTNER_APP_SUBSCRIBED: 'PARTNER_APP_SUBSCRIBED',
  CLIENT_APP_CREATED: 'CLIENT_APP_CREATED',
  CLIENT_APP_SUBSCRIBED: 'CLIENT_APP_SUBSCRIBED',
  COMPLETE: 'COMPLETE'
}

export const ZENDESK_LINK = 'https://partnersupport.adp.com/hc/en-us/requests/new';
export const ZENDESK_LINK_API_CENTRAL = 'https://clientsupport.adp.com/hc/en-us/requests/new';

export const DEV_PORTAL_LINK = 'https://developers.adp.com';

export const PAGE_SIZES = [{ label: '10', value: 10 }, { label: '20', value: 20 }, { label: '40', value: 40 }, { label: '60', value: 60 }, { label: '80', value: 80 }, { label: '100', value: 100 }];

export const SHELL_NAV_ICON = 'items-center mr-24 cursor-pointer w-10'
